const translations = {
  // Navbar
  "nav.home": "Home",
  "nav.services": "Services",
  "nav.products": "Products",
  "nav.whatsapp": "WhatsApp",
  "nav.quote": "Request a Quote",
  "nav.whatsapp_full": "Chat on WhatsApp",

  // Hero
  "hero.badge": "Over 30 years of printing experience",
  "hero.title1": "Professional customization that makes",
  "hero.title2": "your brand stand out",
  "hero.subtitle": "Specialists in DTF printing, sublimation and commercial solutions. Superior quality on t-shirts, caps, mugs and more — ready to elevate your business.",
  "hero.cta_quote": "Request a Quote",
  "hero.cta_whatsapp": "Message on WhatsApp",
  "hero.cta_contact": "Contact Us",
  "hero.stat1": "Years of experience",
  "hero.stat2": "Years as a company",
  "hero.stat3": "Quality guaranteed",
  "hero.scroll": "Discover more",

  // Services
  "services.tag": "What we do",
  "services.title": "Our Professional Services",
  "services.subtitle": "Complete customization and printing solutions for businesses that want to stand out.",
  "services.dtf.title": "DTF Printing",
  "services.dtf.desc": "Direct-to-film transfer technology with vibrant colors and exceptional durability. Ideal for t-shirts, hoodies and any textile garment.",
  "services.dtf.badge": "High durability",
  "services.sub.title": "Sublimation",
  "services.sub.desc": "Permanent customization on mugs, bottles, rigid items and polyester garments. Colors that never fade over time.",
  "services.sub.badge": "Permanent colors",
  "services.com.title": "Commercial Printing",
  "services.com.desc": "Flyers, business cards, banners and high-quality advertising materials to boost your business and strengthen your brand.",
  "services.com.badge": "Professional branding",
  "services.micro.title": "Perforated Vinyl",
  "services.micro.desc": "Perforated vinyl for vehicles, storefronts and businesses. High-impact outdoor advertising with interior visibility.",
  "services.micro.badge": "Outdoor advertising",
  "services.cta": "Request a Quote",

  // Products
  "products.tag": "Catalog",
  "products.title": "Products That Transform Your Brand",
  "products.subtitle": "From apparel to promotional items, we customize everything with the highest quality.",
  "products.cta": "Get Quote",
  "products.view_all": "View Full Catalog",
  "products.cat.all": "All",
  "products.cat.textiles": "Apparel",
  "products.cat.caps": "Caps",
  "products.cat.drinkware": "Drinkware",
  "products.cat.promo": "Promotional",
  "products.not_found": "Can't find what you're looking for?",
  "products.not_found_sub": "Contact us and we'll customize any product for your brand.",

  // Value
  "value.tag": "Why choose us",
  "value.title": "Experience That Speaks for Itself",
  "value.stat1.label": "Years of experience",
  "value.stat1.desc": "Decades of knowledge in the printing and customization industry.",
  "value.stat2.label": "Years as a company",
  "value.stat2.desc": "Printven LLC established and growing with satisfied customers.",
  "value.stat3.label": "Commitment to quality",
  "value.stat3.desc": "Every project receives our maximum attention and quality standards.",
  "value.tag2": "Our values",
  "value.title2": "Quality, Commitment and Experience",
  "value.subtitle2": "Over 30 years of accumulated experience back us in every project we undertake.",
  "value.v1.title": "Superior Quality",
  "value.v1.desc": "We use the best materials and technologies to guarantee exceptional results in every order.",
  "value.v2.title": "On-Time Delivery",
  "value.v2.desc": "We respect agreed delivery times because we know your business can't wait.",
  "value.v3.title": "Personalized Attention",
  "value.v3.desc": "Each client receives dedicated attention from quote to final product delivery.",
  "value.v4.title": "Full Guarantee",
  "value.v4.desc": "We back every product with our satisfaction guarantee. Your trust is our priority.",

  // Commercial
  "commercial.tag": "Commercial Solutions",
  "commercial.title": "Boost your business with professional print materials",
  "commercial.desc": "From business cards to vehicle perforated vinyl, we offer complete commercial printing solutions that strengthen your brand image.",
  "commercial.i1.title": "High-Impact Flyers",
  "commercial.i1.desc": "Eye-catching designs that capture your audience's attention.",
  "commercial.i2.title": "Business Cards",
  "commercial.i2.desc": "Professional first impression that leaves a mark on your clients.",
  "commercial.i3.title": "Advertising Materials",
  "commercial.i3.desc": "Banners, posters and branding materials for your business.",
  "commercial.i4.title": "Perforated Vinyl",
  "commercial.i4.desc": "For vehicles, storefronts and commercial spaces with full visibility.",
  "commercial.cta": "Request Commercial Quote",
  "commercial.quality": "Commercial Printing",
  "commercial.quality_sub": "Professional quality guaranteed",

  // CTA
  "cta.title": "Ready to make your brand stand out?",
  "cta.subtitle": "Get a personalized quote in minutes. Over 30 years of experience back every product we deliver.",
  "cta.btn1": "Request a Quote Now",
  "cta.btn2": "Chat on WhatsApp",
  "cta.tag": "Start today",

  // Services Page
  "svcpage.tag": "What we offer",
  "svcpage.title": "Professional Printing Services",
  "svcpage.subtitle": "Over 30 years of experience back every service we offer. Quality, precision and reliability in every project.",
  "svcpage.cta_title": "Have a project in mind?",
  "svcpage.cta_sub": "Contact us today and receive a personalized quote with no commitment.",
  "svcpage.quote": "Request a Quote",
  "svcpage.whatsapp": "WhatsApp",

  // Products Page
  "prodpage.tag": "Catalog",
  "prodpage.title": "Customizable Products",
  "prodpage.subtitle": "Explore our full catalog. Every product can be customized with your brand, logo or design.",
  "prodpage.quote": "Request a Quote",
  "prodpage.not_found": "Can't find what you're looking for?",
  "prodpage.not_found_sub": "Contact us and we'll customize any product for your brand.",
  "prodpage.whatsapp": "Chat on WhatsApp",

  // Navbar extra
  "nav.about": "About Us",
  "nav.contact": "Contact",

  // CTA shared
  "cta.quote": "Request a Quote",
  "cta.whatsapp": "Chat on WhatsApp",

  // About Page
  "about.badge": "Our Story",
  "about.hero_title": "Over 30 years printing quality and trust",
  "about.hero_subtitle": "We are Printven LLC, a company specialized in product customization with over 5 years in the market and more than 30 years of accumulated experience in the industry.",
  "about.stat1": "Years of experience",
  "about.stat2": "Years as a company",
  "about.stat3": "Satisfied clients",
  "about.stat4": "Commitment to quality",
  "about.story_badge": "Our story",
  "about.story_title": "From a passion for printing to a reference company",
  "about.story_p1": "Printven LLC was born from decades of accumulated experience in the printing and customization industry. From the beginning, we have dedicated ourselves to offering high-quality solutions that help businesses and entrepreneurs stand out.",
  "about.story_p2": "With over 30 years of industry knowledge, we have adopted the most advanced technologies such as DTF printing and sublimation, always staying at the forefront of the industry.",
  "about.story_p3": "Today, from Indianapolis, IN, we serve clients throughout the region with the same commitment to quality, reliability and personalized attention that has defined us from day one.",
  "about.years_exp": "Years of experience",
  "about.timeline_badge": "Our journey",
  "about.timeline_title": "A path of constant growth",
  "about.m1_title": "The beginnings in printing",
  "about.m1_desc": "We began our journey in the printing and customization industry, accumulating knowledge and experience that would become our greatest strength.",
  "about.m2_title": "Service expansion",
  "about.m2_desc": "We incorporated new technologies and expanded our service offering to meet the growing needs of the customization market.",
  "about.m3_title": "Founding of Printven LLC",
  "about.m3_desc": "With over 25 years of accumulated experience, we founded Printven LLC in Indianapolis, IN, to offer professional DTF printing, sublimation and more.",
  "about.m4_title": "Leaders in customization",
  "about.m4_desc": "Today we are industry leaders, with cutting-edge technology, a committed team and hundreds of satisfied clients who trust our quality.",
  "about.values_badge": "What defines us",
  "about.values_title": "Our Values",
  "about.v1_title": "Uncompromising quality",
  "about.v1_desc": "Every product that leaves our facility meets the highest quality standards.",
  "about.v2_title": "Guaranteed punctuality",
  "about.v2_desc": "We meet agreed delivery times because we respect your time and your business.",
  "about.v3_title": "Customer care",
  "about.v3_desc": "We accompany each client from the first consultation to final delivery with total dedication.",
  "about.v4_title": "Constant innovation",
  "about.v4_desc": "We adopt the latest technologies to always offer the best solutions on the market.",
  "about.commitment_badge": "Our commitment",
  "about.commitment_title": "Your success is our goal",
  "about.commitment_p1": "At Printven LLC we understand that every customized product is an extension of your brand. That's why we treat every order with the same dedication and care, regardless of size.",
  "about.commitment_p2": "Our team is ready to advise you, help you choose the best printing method and ensure the final result exceeds your expectations.",

  // Contact Page
  "contact.badge": "We're here to help",
  "contact.hero_title": "Let's talk about your next project",
  "contact.hero_subtitle": "Request your personalized quote or message us on WhatsApp. We respond quickly.",
  "contact.info_title": "Contact information",
  "contact.info_desc": "We are available to assist you and answer all your questions about our services.",
  "contact.info_phone": "Phone",
  "contact.info_location": "Location",
  "contact.info_whatsapp": "WhatsApp",
  "contact.wa_title": "Prefer WhatsApp?",
  "contact.wa_desc": "Write to us directly and get a response in minutes.",
  "contact.form_title": "Request Your Quote",
  "contact.form_desc": "Fill out the form and we'll contact you shortly with a personalized proposal.",
  "contact.field_name": "Full name",
  "contact.field_email": "Email address",
  "contact.field_phone": "Phone",
  "contact.field_service": "Service of interest",
  "contact.field_message": "Message",
  "contact.placeholder_name": "Your full name",
  "contact.placeholder_email": "you@email.com",
  "contact.placeholder_phone": "+1 (000) 000-0000",
  "contact.select_service": "Select a service...",
  "contact.placeholder_message": "Tell us about your project, quantity, product type...",
  "contact.submit": "Send Request",
  "contact.sending": "Sending...",
  "contact.success_title": "Message sent!",
  "contact.success_desc": "Thank you for contacting us. We will respond shortly with your personalized quote.",
  "contact.send_another": "Send another message",
  "contact.error_msg": "There was an error sending. Please try again.",

  // Footer
  "footer.tagline": "Professional customization since 2019",
  "footer.nav": "Navigation",
  "footer.services": "Services",
  "footer.contact": "Contact",
  "footer.chat": "Chat with us",
  "footer.rights": "All rights reserved.",
};

export default translations;
